// extracted by mini-css-extract-plugin
export default {"star-icon":"_1rrimt6","starIcon":"_1rrimt6","rating":"_11q1e2f"};